<template>
  <div class="subscription-pay">
    <div class="pay-top-bar">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack">Back</el-button>
    </div>
    <div id="checkout" style="padding: 20px;background: #fff;">
      <!-- Checkout will insert the payment form here -->
    </div>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'

export default {
  name: 'SubscriptionPay',
  data() {
    return {
      order_id: this.$route.query.order_id
    }
  },
  mounted() {
    this.ensureStripeLoaded().then(() => {
      this.requestOrderInfo()
    })
  },
  methods: {
    ensureStripeLoaded() {
      return new Promise((resolve) => {
        if (typeof Stripe !== 'undefined') {
          resolve()
          return
        }
        const script = document.querySelector('script[src*="stripe"]')
        if (script) {
          script.addEventListener('load', () => resolve())
          script.addEventListener('error', () => resolve())
        } else {
          const s = document.createElement('script')
          s.src = 'https://js.stripe.com/v3/'
          s.onload = () => resolve()
          s.onerror = () => resolve()
          document.head.appendChild(s)
        }
      })
    },
    async requestOrderInfo() {
      const response = await postRequest('getSubscriptionOrder', { order_id: this.order_id })
      let order = response.data.data
      this.handleOrderData(this.order_id, order)
    },
    handleOrderData(order_id, order) {
      let totalAmount = parseFloat(order.total_price).toFixed(2)
      let line_items = [{
        price_data: {
          currency: "usd",
          product_data: {
            name: `LearningFirst Subscription - ${order.quantity} students × ${order.duration_months} months`,
          },
          unit_amount: totalAmount * 100,
        },
        quantity: 1,
      }]
      this.pay(order_id, line_items)
    },
    goBack() {
      this.$router.go(-1)
    },
    pay(order_id, line_items) {
      const stripe = Stripe(
        "pk_live_51P128qP6BucL4HOzvB46mZ4G6n5nyygpBo3DmJPSEPo5NSdeTsvrFxVO4PQUF3vO6WhWd1nhEgYcrQ63cFZSpMo500NFO4Pe0i"
      )

      const fetchClientSecret = async () => {
        const response = await fetch(
          "https://web-backend.reachable-edu.com/Stripe/EclubSubscriptionEmbedPay.php",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_id: order_id,
              line_items: line_items,
            }),
          }
        )
        let result = await response.json()
        const { clientSecret } = result
        return clientSecret
      }

      stripe.initEmbeddedCheckout({
        fetchClientSecret,
      }).then(checkout => {
        checkout.mount("#checkout")
      })
    }
  }
}
</script>

<style scoped>
.subscription-pay {
  padding: 20px;
}

.pay-top-bar {
  margin: 0 0 12px 20px;
}

.pay-top-bar .el-button {
  color: #FF8833;
  font-size: 15px;
  padding: 0;
}
</style>
